import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelectChange } from '@angular/material/select';
import { TranslatableKey } from '@app/types/translatable.type';
import { RoleNameDisplayOptions } from '@app/types/translatables/role-display.options';
import { BaseForm } from '@forms/base.form';
import { Role } from '@models/account/role.model';
import { ApprovalWorkflow } from '@models/approvals/approval-workflow.model';
import { ChangeRequestTemplate } from '@models/change-requests/change-request-template.model';
import { getRoleAccessLevelDescription } from '@settings/functions/role-access-level-description';

@Component({
    templateUrl: './requesters-and-approvers.form.html',
    selector: 'app-requesters-and-approvers-form',
    styleUrls: ['./requesters-and-approvers.style.scss'],
})
export class RequestersAndApproversForm extends BaseForm {
    @Output() rolesChanged: EventEmitter<number[]> = new EventEmitter<number[]>();
    @Output() notifySubjectChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() approvalWorkflow: ApprovalWorkflow;
    @Input() changeRequestTemplate: ChangeRequestTemplate;
    @Input() selectedRoleIds: number[] = [];
    @Input() selectedRoleNames: TranslatableKey[] = [''];
    @Input() roles: Role[] = [];
    @Input() notifySubject = false;
    roleNameDisplay = RoleNameDisplayOptions;
    getRoleAccessLevelDescription = getRoleAccessLevelDescription;

    isDefaultAdmin(role: Role): boolean {
        return role.isImmutable && role.name === 'Admin';
    }

    onSelectionChange($event: MatSelectChange): void {
        const newRoles = [...$event.value];
        this.rolesChanged.emit(newRoles);
    }

    onNotifySubjectChange($event: MatCheckboxChange): void {
        const notifySubject = $event.checked;
        this.notifySubjectChanged.emit(notifySubject);
    }
}
